import axios from 'axios';
import { OAuthGrantType } from '@manifoldxyz/manifold-sdk';

type Subscriber = {
  id: string;
  email: string;
  verified: boolean;
  subscriptions: Subscription[];
};

type Subscription = {
  id: string;
  creatorAddress: string;
};

export async function getOAuth(delayAuth = false): Promise<string | null> {
  return window.ManifoldEthereumProvider.getOAuth({
    grantType: OAuthGrantType.SIGNATURE,
    appName: 'Manifold Notifications',
    clientId: '02865a407876e82f4389f70992c25323e967504d37663290f11fd49e79b607e0',
    strictAuth: true,
    delayAuth: delayAuth
  });
}

async function getHeaders() {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${await getOAuth()}`
  } as {
    [key: string]: string;
  };
}

const BASE_URL =
  process.env.NODE_ENV !== 'development'
    ? 'https://subscriptions.api.manifoldxyz.dev'
    : 'http://localhost:3000';

export const getSubscriber = async (
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  walletAddress: string
): Promise<Subscriber | undefined> => {
  try {
    const response = await axios.get(`${BASE_URL}/subscriber/${walletAddress}`, {
      headers: await getHeaders()
    });
    return await response.data;
  } catch (error) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (error.response.status === 404) {
      return undefined;
    }

    throw new Error('Failed to get subscriber');
  }
};

export const subscribe = async (
  creatorAddress: string,
  email: string,
  subscriberWallet: string
): Promise<void> => {
  // subscribes to a creator
  try {
    await axios.post(
      `${BASE_URL}/subscriptions/${creatorAddress}`,
      {
        email,
        subscriberWallet: subscriberWallet.toLowerCase()
      },
      {
        headers: await getHeaders()
      }
    );
  } catch (error) {
    throw new Error('Failed to subscribe');
  }
};

export const resendVerificationEmail = async (walletAddress: string): Promise<void> => {
  // subscribes to a creator
  try {
    await axios.post(`${BASE_URL}/subscriber/${walletAddress}/reverify`, {
      headers: await getHeaders()
    });
  } catch (error) {
    throw new Error('Failed to send verification email');
  }
};

export const unsubscribeFromCreator = async (
  creator: string,
  subscriber: string
): Promise<void> => {
  try {
    await axios.delete(`${BASE_URL}/subscriptions/${creator}`, {
      headers: await getHeaders(),
      data: {
        subscriber: subscriber.toLowerCase()
      }
    });
  } catch (error) {
    throw new Error('Failed to unsubscribe');
  }
};
